import { render, staticRenderFns } from "./OrgSchools.vue?vue&type=template&id=1c2c1948&scoped=true&"
import script from "./OrgSchools.vue?vue&type=script&lang=js&"
export * from "./OrgSchools.vue?vue&type=script&lang=js&"
import style0 from "./OrgSchools.vue?vue&type=style&index=0&id=1c2c1948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c1948",
  null
  
)

export default component.exports